import { render, staticRenderFns } from "./ListPaginator.vue?vue&type=template&id=672e5da1&scoped=true&"
import script from "./ListPaginator.vue?vue&type=script&lang=ts&"
export * from "./ListPaginator.vue?vue&type=script&lang=ts&"
import style0 from "./ListPaginator.vue?vue&type=style&index=0&id=672e5da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e5da1",
  null
  
)

export default component.exports